module.exports = __webpack_public_path__ + "static/media/edit.e213f7cb.svg";